/* global axios */
import ApiClient from './ApiClient';

// Vozes PRONTAS do Voice Studio (arquétipos). O runtime fica fechado no
// firewall e o navegador não o alcança — tudo passa pelo proxy do ChatSuite.
class VoiceStudioAPI extends ApiClient {
  constructor() {
    super('voice_studio', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  // Baixa a amostra COM autenticação. Um <audio src="..."> não carrega os
  // cabeçalhos de auth da API e leva 401 — por isso vem como blob.
  preview(id) {
    return axios.get(`${this.url}/${id}/preview`, { responseType: 'blob' });
  }

  // Converte o arquétipo num perfil utilizável e devolve o id que vai em tts_voice.
  use(id, name) {
    return axios.post(`${this.url}/${id}/use`, { name });
  }
}

export default new VoiceStudioAPI();
